import type { AssetBooking, AssetBookingDto } from "@/domain/asset";
import { apiClientJSONAssets } from "../apiClient";

/** Raw API response type for AssetBooking (dates as strings before conversion) */
interface AssetBookingRaw extends Omit<AssetBooking, "startDate" | "endDate"> {
  startDate: string;
  endDate: string;
}

export const getAssetBookings = (): Promise<AssetBooking[]> => {
  return apiClientJSONAssets
    .get("/booking")
    .then((r) => r.data)
    .then((items: AssetBookingRaw[]) =>
      items.map<AssetBooking>((i) => ({
        ...i,
        startDate: new Date(i.startDate),
        endDate: new Date(i.endDate),
      }))
    );
};

export const createAssetBooking = (dto: AssetBookingDto): Promise<void> => {
  return apiClientJSONAssets.post("/booking", dto);
};

export const deleteAssetBooking = (bookingId: number): Promise<void> => {
  return apiClientJSONAssets.delete(`/booking/${bookingId}`);
};
